// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/SX_SAP_PP.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.generatepcn-form {
  background: rgba(255, 255, 255, 0.5);
  /* background: rgba(255, 255, 255, 0.25); */
  /* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); */
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  /* margin-bottom: 20px; */
}

.generatepcn-input {
  padding: 5px 10px;
  margin-left: 10px;
  border-radius: 5px;
  border: none;
  background-color: #f2f2f2;
}

.generatepcn-button {
  padding: 5px 10px;
  margin-left: 10px;
  border-radius: 5px;
  border: none;
  background-color: #333;
  color: #fff;
  cursor: pointer;
}

.generatepcn-button:hover {
  background-color: #666;
}

.success-message {
  color: green;
  margin-top: 10px;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  text-align: center;
}

.popup-content h2 {
  margin-top: 0;
}

.popup-content p {
  font-size: 1.2rem;
}

.popup-content button {
  margin-top: 10px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.labelClass {
  display: flex;
  justify-content: center;
  margin: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/GeneratePCN/GeneratePCN.css"],"names":[],"mappings":"AAAA;EACE,yDAAgE;EAChE,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,sDAAsD;EACtD,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".container {\n  background-image: url(\"../../../../public/images/SX_SAP_PP.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.generatepcn-form {\n  background: rgba(255, 255, 255, 0.5);\n  /* background: rgba(255, 255, 255, 0.25); */\n  /* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); */\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  /* margin-bottom: 20px; */\n}\n\n.generatepcn-input {\n  padding: 5px 10px;\n  margin-left: 10px;\n  border-radius: 5px;\n  border: none;\n  background-color: #f2f2f2;\n}\n\n.generatepcn-button {\n  padding: 5px 10px;\n  margin-left: 10px;\n  border-radius: 5px;\n  border: none;\n  background-color: #333;\n  color: #fff;\n  cursor: pointer;\n}\n\n.generatepcn-button:hover {\n  background-color: #666;\n}\n\n.success-message {\n  color: green;\n  margin-top: 10px;\n}\n\n.error-message {\n  color: red;\n  margin-top: 10px;\n}\n\n.popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.popup-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  text-align: center;\n}\n\n.popup-content h2 {\n  margin-top: 0;\n}\n\n.popup-content p {\n  font-size: 1.2rem;\n}\n\n.popup-content button {\n  margin-top: 10px;\n  padding: 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.labelClass {\n  display: flex;\n  justify-content: center;\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
